import { useCallback } from "react";
import { Product } from "../../my-lemonade-library/model/Catalog";
import { ProductExtended } from "../../my-lemonade-library/model/ProductExtended/ProductExtended";

export const useQuantity = (product?: Product | ProductExtended | null) => {
    const getRemainingQty = useCallback((): number | undefined => {

        if (!product?.skus || product.skus.length === 0) {
            return undefined;
        }

        if (product.skus.length === 1) {
            return product.skus[0].remaining_qty;
        }

        return undefined;
    }, [product?.skus]);

    return {
        remainingQty: getRemainingQty()
    }
}